import React from 'react';

import styled from 'styled-components';

import ValueDifference from '../ValueDifference';

const Container = styled.div`
  display: flex;
  gap: 4px;
  color: var(--text-primary);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
`;

interface ValueProps {
  positive: boolean;
  neutral?: boolean;
}

const Value = styled.div<ValueProps>`
  color: ${({ neutral, positive }) =>
    neutral ? 'var(--text-primary)' : positive ? 'var(--positive-green)' : 'var(--negative-orange)'};
`;

interface Props {
  label: string;
  value: string;
  positive: boolean;
  widgetType?: number;
  valueDisplay?: number;
  difference?: number | null;
}

const CardFooter = ({ label, value, positive, widgetType, valueDisplay, difference }: Props) => (
  <Container>
    <span>{label}</span>
    <Value
      positive={positive}
      neutral={difference != null && difference !== 0}
    >
      {value}
      {difference != null && (
        <ValueDifference difference={difference} widgetType={widgetType ?? 0} valueDisplay={valueDisplay} />
      )}
    </Value>
  </Container>
);

export default CardFooter;
